import { put, takeLatest, call, select } from "redux-saga/effects";
import { fetchPassbookSuccess, fetchPassbookError } from "../actions/passbook.js";
import { FETCH_PASSBOOK } from "../actions/types";
import { fetchPassbook as fetchPassbookAPI } from "../services/passbook";
import { showErrorMsg } from "../actions/snackbar";
import { validateSession } from './session';

function* fetchPassbook(action) {
  try {
    const { sessionId } = yield select((state) => state.auth || {});
    const { passbook: oldPassbook = [] } = yield select((state) => state.passbook || {});
    const { firstFetch = true} = action.payload || {};
    const {data: passbook, count } = yield call(validateSession, fetchPassbookAPI, action.payload, sessionId);
    let parsedPassbook = [];
    // eslint-disable-next-line no-unused-vars
    for (const data of passbook) {
      parsedPassbook.push(data);
      if (data.txn_type === 'M') {
        break;
      }
    }
    if (firstFetch && oldPassbook && oldPassbook.length > 0) {
      parsedPassbook = [...oldPassbook, ...parsedPassbook];
    }

    yield put(fetchPassbookSuccess({passbook: parsedPassbook, count}));
  } catch (error) {
    yield put(fetchPassbookError(error));
    yield put(showErrorMsg(error.message));
  }
}

export function* watchPassbook() {
  yield takeLatest(FETCH_PASSBOOK, fetchPassbook);
}